import {saveIcon} from '@deanone/dean-components';
<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="'Kies een ' + title"
      :small="true"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>

      <dean-select-form-row :placeholder="'Kies een ' + title" :label='title'
                            :options='payloadData.options'
                            :value="currentlySelectedOption(selectedOption, payloadData.options)"
                            id="options"
                            @input="selectedOption = $event.value"></dean-select-form-row>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="select()">Selecteren</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    checkmarkIcon,
    forbiddenIcon,
    // COMPONENTS
    deanDialog,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanAlertDialog from '@/components/deanComponents/deanAlertDialog.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      DeanNotification,
      deanDialog,
      deanButton,
      deanAlertDialog,
      DeanSelectFormRow,
    },
  })

  export default class SelectOptionDialog extends Vue {

    // DATA
    @Prop() public payloadData!: {
      options: [string],
      title: string,
      callback: (option: string) => void, // should be a function that does something with the selected value
    };

    public selectedOption: string | null = null;

    // COMPUTED
    get title(): string {
      return this.payloadData.title || 'optie';
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public select() {
      if (this.selectedOption !== null) {
        deanDialogBus.$emit('close');
        if (typeof(this.payloadData.callback) === typeof(Function)) {
          this.payloadData.callback(this.selectedOption);
        }
      } else {
        this.$toast({
          title: 'Selecteer een optie',
          text: 'Selecteer a.u.b. eerst een optie voor dat u op selecteren klikt.',
          theme: 'info',
        });
      }

    }

    public currentlySelectedOption(value: any, options: any) {
      if (value !== null) {
        const foundKey: any = Object.keys(options).find((key) => options[key].value === value);
        return foundKey != null ? options[foundKey] : null;
      }
      return null;
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  :deep(.dean-button) {
    .dean-button-theme-grey {
      &:hover {
        background: white;
        color: var(--color-dark-shade-4);
        cursor: default;
      }
    }
  }

</style>
